import { render, staticRenderFns } from "./TeachEssay.vue?vue&type=template&id=a9a2720a&scoped=true"
import script from "./TeachEssay.vue?vue&type=script&lang=js"
export * from "./TeachEssay.vue?vue&type=script&lang=js"
import style0 from "./TeachEssay.vue?vue&type=style&index=0&id=a9a2720a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../.yarn/__virtual__/vue-loader-virtual-45869d479f/4/.yarn/berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a2720a",
  null
  
)

export default component.exports